import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import ReplayIcon from "@mui/icons-material/Replay";
import { ReviseMRQTable } from "./table/ReviseMRQTable";
import { secondAxios } from "../../../../../../../api/axios";
import ColoredSnackbar from "../../../../../../../components/ColoredSnakebar";

export default function ReviseMrqAction({ plant, selectedRowsData, disabled }) {
  const [open, setOpen] = useState(false);

  const [mrqMaterials, setMrqMaterials] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const previousMrq = selectedRowsData[0]?.left?.mrqMaterials?.[0]?.mrq;

  const mrqDetails = {
    ...previousMrq,
    parentId: previousMrq?.id,
    rev: (Number(previousMrq?.rev) + 1 || 1).toString(),
  };
  delete mrqDetails?.id;
  delete mrqDetails?.createdAt;
  delete mrqDetails?.updatedAt;

  const handleConfirm = async () => {
    const createdMrq = {
      ...mrqDetails,
      plantName: plant.name,

      mrqMaterials: mrqMaterials.map((m) => {
        return {
          ...m,
        };
      }),
    };
    console.log("Confirm Revise MRQ", createdMrq);

    const { data } = await secondAxios.post("/mrq/", createdMrq);
    console.log("res", data);

    if (data?.mrq?.id) {
      setOpen(false);
      setSnackbar({
        open: true,
        message: "MRQ revised successfully!",
        severity: "success",
      });
    } else {
      setSnackbar({
        open: true,
        message: "Failed to revise MRQ. Please try again.",
        severity: "error",
      });
    }
  };

  return (
    <>
      <Button
        variant="contained"
        startIcon={<ReplayIcon />}
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        Revise MRQ
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Revise MRQ</DialogTitle>

        <DialogContent>
          <ReviseMRQTable
            plant={plant}
            mrqDetails={mrqDetails}
            data={selectedRowsData}
            mrqMaterials={mrqMaterials}
            setMrqMaterials={setMrqMaterials}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>

          <Button variant="contained" onClick={handleConfirm}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <ColoredSnackbar
        open={snackbar.open}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
        severity={snackbar.severity}
      />
    </>
  );
}
